import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import SelectInput from '@/common/components/SelectInput';
import useSearchBox from '../hooks/useSearchBox';
import { DEVICE_OPTIONS } from '../constants/deviceOptions';
import { SOURCE_OPTIONS } from '../constants/sourceOptions';
import { REPORT_QUIZ_DOMAINS } from '../constants/domains';

const QuizReportSearchBox = ({ handleSearchCallback }) => {
	const hook = useSearchBox({ handleSearchCallback });

	return (
		<form onSubmit={(e) => hook.handleSearch(e)}>
			<SearchBarCenter>
				<div>
					<Input
						name='Events date from'
						width={180}
						color={Colors.darkBlue}
						inputRef={hook.dateFromRef}
						type='date'
						value={hook.today}
						inputWidth={140}
						hasIncDec
					/>
					<Input
						name='Events date to'
						width={180}
						color={Colors.darkBlue}
						inputRef={hook.dateToRef}
						type='date'
						value={hook.today}
						inputWidth={140}
						hasIncDec
					/>
					<SelectInput
						name='Domain'
						color={Colors.darkBlue}
						width={180}
						selectWidth={240}
						required
						selected={hook.selectedDomain}
						setSelected={hook.setSelectedDomain}
						options={REPORT_QUIZ_DOMAINS.map((domain) => {
							return { label: domain, value: domain };
						})}
					/>
				</div>
				<div>
					<SelectInput
						name='Device'
						color={Colors.darkBlue}
						width={180}
						selectWidth={200}
						selected={hook.selectedDevice}
						setSelected={hook.setSelectedDevice}
						options={DEVICE_OPTIONS.map((device) => {
							return { label: device, value: device };
						})}
					/>
					<SelectInput
						name='Source'
						color={Colors.darkBlue}
						width={180}
						selectWidth={200}
						selected={hook.selectedSource}
						setSelected={hook.setSelectedSource}
						options={SOURCE_OPTIONS.map((source) => {
							return { label: source, value: source };
						})}
					/>
				</div>
				<ActionButton type='submit' text='Search' />
			</SearchBarCenter>
		</form>
	);
};

export default QuizReportSearchBox;
